// extracted by mini-css-extract-plugin
export default {"container":"_1wStUyY4M6TXIO_yjuiIjR","image":"_3O5dYNbEj_mF0kwMnu5jI6"};